import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";
import axiosInstance from "../../axiosInstance";

interface ProductCategory {
    product_category_idx: number;
    category_name: string;
}

interface ProductImage {
    file_idx: number;
    file_name: string;
    original_name: string;
}

export interface ProductData {
    product_code_idx: number;
    product_code: string;
    product_code_name: string;
    product_idx: number;
    product_name: string;
    product_amount: number;
    product_memo: string;
    status: boolean;
    reg_date: string;
    /* 삭제건 목록에서 삭제 시각으로 쓴다 */
    update_date: string | null;
    product_category: ProductCategory;
    product_image: ProductImage;
}

interface GetProductResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: ProductData[];
}

export const useGetGoods = (
    page: number,
    pageSize: number,
    search?: string,
    searchtxt?: string,
    field?: string,
    sortDirection?: string,
    /* 켜면 삭제된 상품만 본다. 주문판매의 '삭제건만 보기' 와 같은 쓰임이다. */
    showDeleted?: boolean,
): UseQueryResult<GetProductResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetProductResponse, Error>({
        queryKey: ["getGoodsList", page, pageSize, search, searchtxt, field, sortDirection, showDeleted],
        queryFn: async () => {
            const encodedSearchTxt = encodeURIComponent(searchtxt || "");
            const encodedSearch = encodeURIComponent(search || "");

            let url = `${enum_api_uri.get_product}?page=${page}&limit=${pageSize}&search=${encodedSearch}&searchtxt=${encodedSearchTxt}`;

            if (sortDirection) {
                url += `&field=${field}&direction=${sortDirection}`;
            }

            if (showDeleted) {
                url += `&is_delete=Y`;
            }

            const response = await axiosInstance.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            return response.data.data;
        },

        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                    current_page: page,
                };
            }
            return undefined;
        },
    });
};
